module.exports = __webpack_public_path__ + "static/media/jennie.391a768e.png";